const MINIMUM_PPI = 150;
export const SCALE_MAX = 72 / MINIMUM_PPI;

export const previewUrls = new Map<string, string>();

import { absolutePhotoUrl } from '@apps/card/utils/mediaService';
export { absolutePhotoUrl };

/** Path segment that stock template assets (served from `/media/paper/`) resolve to. */
const STATIONERY_TEMPLATE_ASSET_PATH = '/media/paper/';

/**
 * Stock template photos (e.g. the autofilled images in cutline / penmanship save-the-date
 * templates) resolve to `/media/paper/<templateId>.<hash>.<ext>`, while user-uploaded photos
 * resolve to `/media/<eventId>/<timestamp>.<ext>`. The `/media/paper/` path is the most reliable
 * signal — stock srcs have no slash, so `absolutePhotoUrl` always routes them there. Used to skip
 * resolution warnings for photos the user never chose.
 */
export function isStationeryTemplateStockImage(src: string | null | undefined): boolean {
  if (!src) return false;
  try {
    return new URL(absolutePhotoUrl(src)).pathname.startsWith(STATIONERY_TEMPLATE_ASSET_PATH);
  } catch {
    return false;
  }
}
